import React, { useState, useEffect } from "react";
import { Box, Typography, IconButton, TextField, Button } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import RemoveIcon from "@mui/icons-material/Remove";
import { useDispatch } from "react-redux";
import { addChatWindow, removeChatWindow } from "../Redux/Slice/dataSlice";
import { getDatabase, ref, onValue } from "firebase/database";
import socketService from "socket/SocketService";

const ChatWindow = ({ userId, username, index }) => {
  const [isMinimized, setIsMinimized] = useState(false);
  const [isVisible, setIsVisible] = useState(true);
  const [message, setMessage] = useState("");
  const [chatMessages, setChatMessages] = useState([]);
  const dispatch = useDispatch();

  const database = getDatabase();

  const positionOffset = 320;
  const windowWidth = 300;
  const windowHeight = 300;
  const xOffset = index * positionOffset;
  const yOffset = 0;

  useEffect(() => {
    const escortRef = ref(database, `users/${userId}/ShortDistance_Escort`);

    const unsubscribe = onValue(escortRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        const escortArray = Object.values(data);
        const lastEscort = escortArray[escortArray.length - 1];
        const allChat = Object.values(lastEscort?.chat || {});
        setChatMessages(allChat);
      }
    });

    return () => {
      unsubscribe();
    };
  }, [userId]);

  if (!isVisible) return null;

  const formatTime = (date) => {
    const options = {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    };
    return new Date(date).toLocaleTimeString([], options);
  };

  const handleInput = () => {
    if (message.trim() === "") {
      alert("Please enter a message.");
      return;
    }

    const currentTime = new Date().toISOString();
    socketService.emit("chat", {
      userId: userId,
      message: message,
      isAdmin: true,
      adminId: localStorage.getItem("userId"),
      userName: username,
      time: currentTime,
    });
    setMessage("");
  };

  return (
    <Box
      sx={{
        position: "fixed",
        bottom: 10 + yOffset,
        right: 100 + xOffset,
        width: windowWidth,
        border: "1px solid #ccc",
        borderRadius: 2,
        boxShadow: 3,
        backgroundColor: "white",
        overflow: "hidden",
        zIndex: 2000,
      }}
    >
      <Box
        sx={{
          backgroundColor: "#3f51b5",
          color: "white",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "8px 12px",
        }}
      >
        <Typography variant="subtitle1" sx={{ color: "#FFFFFF" }}>
          {username}
        </Typography>
        <Box>
          <IconButton
            size="small"
            sx={{ color: "#FFFFFF" }}
            color="inherit"
            onClick={() => setIsMinimized(!isMinimized)}
          >
            <RemoveIcon />
          </IconButton>
          <IconButton
            size="small"
            color="inherit"
            sx={{ color: "#FFFFFF" }}
            onClick={() => {
              dispatch(removeChatWindow(userId));
            }}
          >
            <CloseIcon />
          </IconButton>
        </Box>
      </Box>

      {!isMinimized && (
        <Box
          sx={{
            height: 250,
            padding: 2,
            display: "flex",
            flexDirection: "column",
            gap: 1,
            backgroundColor: "#EDEFF2",
          }}
        >
          <Box
            sx={{
              flexGrow: 1,
              overflowY: "auto",
              padding: 1,
              borderRadius: 3,
            }}
          >
            {/* Display dynamic chat messages */}
            {chatMessages.length === 0 ? (
              <Typography variant="body2">No chat messages yet.</Typography>
            ) : (
              chatMessages.map((msg, index) => (
                <Box
                  key={index}
                  sx={{
                    display: "flex",
                    flexDirection: msg.isAdmin ? "row-reverse" : "row",
                    alignItems: "center",
                    marginBottom: 1,
                  }}
                >
                  <Box
                    sx={{
                      maxWidth: "70%",
                      wordWrap: "break-word",
                      backgroundColor: msg.isAdmin ? "#d1e7dd" : "#f8d7da",
                      borderRadius: 2,
                      padding: 1,
                      marginLeft: msg.isAdmin ? 0 : 1,
                      marginRight: msg.isAdmin ? 1 : 0,
                    }}
                  >
                    <Typography variant="body2" sx={{ textAlign: msg.isAdmin ? "right" : "left" }}>
                      {msg?.message}
                    </Typography>
                    <Typography
                      variant="caption"
                      sx={{ textAlign: msg.isAdmin ? "right" : "left", color: "gray" }}
                    >
                      {msg?.time ? formatTime(msg.time) : "No time available"}
                    </Typography>
                  </Box>
                </Box>
              ))
            )}
          </Box>
          <TextField
            placeholder="Type a message..."
            variant="outlined"
            fullWidth
            size="small"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
          />
          <Button
            onClick={handleInput}
            type="button"
            variant="contained"
            sx={{
              width: "100%",
              backgroundColor: "#1976d2",
              color: "#ffffff",
              fontWeight: "bold",
              fontSize: "16px",
              textTransform: "none",
              borderRadius: "8px",
              "&:hover": {
                backgroundColor: "#1565c0",
              },
            }}
          >
            Send
          </Button>
        </Box>
      )}
    </Box>
  );
};

export default ChatWindow;
